<template>
  <b-modal size="lg" :hideFooter="true" id="reportModal" @show="onShow">
    <template slot="modal-title">
      <h5><em class="far fa-file-alt"></em> Отчет по тесту</h5>
    </template>
    <template slot="default">
      <div class="reportModal">
        <b-card class="reportModal__correctAnswers" v-if="dCorrectAnswers">
          <b-button
            v-b-toggle.correctAnswers
            variant="outline-primary"
            class="reportModal__correctAnswers__button my-2 d-flex justify-content-between align-items-center"
          >
            Правильные ответы
            <b-badge variant="primary" pill>{{
              dCorrectAnswers.length > 0 ? dCorrectAnswers.length : 0
            }}</b-badge>
          </b-button>
          <b-collapse :visible="dCorrectAnswers.length > 0" id="correctAnswers">
            <b-card>
              <span
                class="reportModal__correctAnswers__span"
                v-for="(id, index) in dCorrectAnswers"
                :key="index"
                @click="() => testReview(id)"
              >
                <a href="#">{{ id }}</a>
              </span>
            </b-card>
          </b-collapse>
        </b-card>
        <b-card class="reportModal__incorrectAnswers" v-if="dIncorrectAnswers">
          <b-button
            v-b-toggle.incorrectAnswers
            variant="outline-dark"
            class="reportModal__incorrectAnswers__button my-2 d-flex justify-content-between align-items-center"
          >
            Неправильные ответы
            <b-badge variant="dark" pill>{{
              dIncorrectAnswers.length > 0 ? dIncorrectAnswers.length : 0
            }}</b-badge>
          </b-button>
          <b-collapse
            :visible="dIncorrectAnswers.length > 0"
            id="incorrectAnswers"
          >
            <b-card>
              <span
                style="color: #373a3d;"
                class="reportModal__incorrectAnswers__span"
                v-for="(id, index) in dIncorrectAnswers"
                :key="index"
                @click="() => testReview(id)"
              >
                <a href="#">{{ id }}</a
                >
              </span>
            </b-card>
          </b-collapse>
        </b-card>
        <div
          class="reportModal__mark"
          v-if="dIncorrectAnswers && dCorrectAnswers"
        >
          <p>
            Правильных: {{ dCorrectAnswers.length }} из
            {{ dIncorrectAnswers.length + dCorrectAnswers.length }}
          </p>
          <div>
            <span class="reportModal__mark__span">Оценка:</span>
            <b-input
              class="reportModal__mark__input"
              v-model="dMark"
              type="number"
              min="2"
              max="5"
            >
            </b-input>
          </div>
        </div>
        <div class="reportModal__footer">
          <p v-show="dMark > 5 || dMark < 2" class="reportModal__mark__invalid">
            Введена некорректная оценка
          </p>
          <b-button
            @click="saveChanges"
            class="reportModal__footer__button mr-4"
            variant="primary"
            :disabled="dMark > 5 || dMark < 2"
          >
            Сохранить изменения
          </b-button>
          <b-button
            @click="closeModal"
            class="reportModal__footer__button"
            variant="outline-primary"
          >
            Отменить изменения
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'

import TestAPI from '@/api/test'

export default {
  name: 'ReportModal',
  data() {
    return {
      dCorrectAnswers: [],
      dIncorrectAnswers: [],
      dMark: 0,
      firstMark: 0
    }
  },
  created() {
    if (!this.test) {
      this.fetchTest({
        courseId: this.$route.params.courseBookId,
        testId: this.$route.params.sectionId
      })
    }
  },
  computed: {
    ...mapGetters({
      studentsReports: 'educationStudentsManagement/getTestProgress',
      reportId: 'educationStudentsManagement/getReportId',
      testReviewMode: 'educationStudentsManagement/getTestReviewMode',
      test: 'test/getTest'
    })
  },
  methods: {
    ...mapMutations({
      setTestReviewMode: 'educationStudentsManagement/setTestReviewMode',
      setSolvedByStudent: 'educationStudentsManagement/setSolvedByStudent',
      setPositions: 'education/setCoursePositions'
    }),
    ...mapActions({
      pushToasts: 'toasts/pushToasts',
      fetchStudentsProgress:
        'educationStudentsManagement/fetchTestStudentsProgress',
      fetchTest: 'test/fetchTest',
      updateBackLink: 'test/updateBackLink'
    }),
    onShow() {
      this.resetModalInfo()
      const report = this.studentsReports.filter((r) => r.id === this.reportId)[0]
        .userTests[0]
      const answers = Object.entries(report.progress)
      this.dCorrectAnswers = answers
        .filter((a) => a[1].isCorrect === true)
        .map(
          (a) => this.test.subSections.filter((ss) => ss.task.id === Number(a[0]))[0]
            .id,
        )
      this.dIncorrectAnswers = answers
        .filter((a) => a[1].isCorrect === false)
        .map(
          (a) => this.test.subSections.filter((ss) => ss.task.id === Number(a[0]))[0]
            .id,
        )
      this.dMark = report.mark
      this.firstMark = report.mark
    },
    closeModal() {
      this.$bvModal.hide('reportModal')
    },
    saveChanges() {
      if (
        this.dMark !== this.firstMark
        && (this.dMark <= 5 && this.dMark >= 2)
      ) {
        TestAPI.updateStudentMark(
          this.$route.params.sectionId,
          this.reportId,
          this.dMark,
        ).then((response) => {
          if (response.status === 200) {
            this.pushToasts({
              title: 'Уведомление',
              message: 'Оценка успешно изменена',
              time: 10
            }).then(() => {
              this.$bvModal.hide('reportModal')
              this.$emit('markUpdated')
            })
          }
        })
      } else {
        this.$bvModal.hide('reportModal')
      }
    },
    resetModalInfo() {
      this.dCorrectAnswers = []
      this.dIncorrectAnswer = []
      this.dMark = 0
      this.firstMark = 0
    },
    testReview(id) {
      this.updateBackLink(this.$route.path)
      this.setPositions()
      this.setTestReviewMode(true)
      const report = this.studentsReports.filter((r) => r.id === this.reportId)[0]
        .userTests[0]
      const answers = Object.entries(report.progress)
      this.setSolvedByStudent(answers)
      this.$nextTick(() => {
        this.$router.push(`/education/${this.$route.params.courseBookId}/section/${
          this.test.id
        }/subsection/${id}`)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.reportModal {
  &__correctAnswers {
    margin-bottom: 20px;

    &__button {
      width: 100%;
    }

    &__span {
      font-size: 1.5em;
      color: #0078c1;
      margin-right: 10px;
    }
  }

  &__incorrectAnswers {
    &__button {
      width: 100%;
    }

    &__span {
      font-size: 1.5em;
      color: #373a3d;
      margin-right: 10px;
    }
  }

  &__mark {
    height: 50px;

    font-size: 1.7em;
    margin-top: 10px;

    p {
      width: 70%;
      margin-bottom: 0;
      margin-right: 0;
      float: left;
    }

    &__span {
      margin-left: 40px;
    }

    &__input {
      text-align: center;
      display: inline;
      float: right;
      width: 7%;
    }

    &__invalid {
      width: 100%;
      position: relative;
      bottom: 20px;
      margin: 0;
      text-align: right;
      color: red;
    }
  }

  &__footer {
    margin-top: 20px;
    width: 100%;

    &__button {
      width: 48%;
    }

    &__button:first-child {
      margin-right: 4%;
    }
  }
}

@media only screen and (max-width: 991px) {
  .reportModal {
    &__footer {
      margin-top: 40px;

      &__button {
        width: 100%;
      }

      &__button:first-child {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
